<template>
    <div class="wrap">
        <!-- <div class="title">{{ title }}</div>
        <div class="titleTime">{{ time }}</div>
        <div class="line"></div> -->
        <div class="first">一、策略构建原理</div>
        <div class="paragraph">
            在沪深300成分股中，精选估值合理、盈利能力强、盈利质量高且被机构看好的股票，通过MTM买入条件捕捉上涨趋势，并结合低换手率控制回撤风险，获取稳健超额收益。
        </div>
        <div class="first">二、选择因子组合</div>
        <div class="paragraph">1、市净率_最新财报（财务类-市场估值）：描述股价相对净资产处于低估位置；</div>
        <div class="paragraph">2、销售净利率_TTM（财务类-盈利能力）：描述企业每单位销售收入创造的净利润水平较高；</div>
        <div class="paragraph">3、扣非净利润/净利润_TTM（财务类-财务质量）：描述获得的净利润多由主营业务创造；</div>
        <div class="paragraph">4、户均持股数（公司资料类-持股结构）：描述股票持股集中度较高，被机构看好；</div>
        <div class="paragraph">5、低换手率（量价类-波动率因子）：描述持仓者惜筹惜售态度较一致；</div>
        <div class="paragraph">6、MTM买入条件（量价类-技术指标）：描述股价加速上涨、多头动能反转。</div>
        <div class="img_center">
            <BaseBigimg :src="require('./img/图片1.png')"></BaseBigimg>
        </div>
        <div class="paragraph">未引入多因子估值数据做风险控制策略回测结果：</div>
        <div class="img_center">
            <BaseBigimg :src="require('./img/图片2.png')"></BaseBigimg>
        </div>
        <div class="paragraph">引入多因子估值数据做风险控制策略回测结果：</div>
        <div class="img_center">
            <BaseBigimg :src="require('./img/图片3.png')"></BaseBigimg>
        </div>
        <div class="first">三、结论</div>
        <div class="paragraph">
            综上所述，运用<common-data name="appShortName_37"/>构建策略，可以为用户挖掘出基本面稳健股票，辅之以量价指标因子最终找到基本面优秀且即将上涨的股票，引入多因子估值数据做风险控制，可显著提升策略的表现，从而帮助用户提前占据领先地位、获取更高收益。
        </div>

         <div style="height:20px"></div>
            <note></note>
            <div style="height:25px"></div>
        </div>
</template>
<script>
    import note from '../note.vue'
    export default {
        components:{
            note
        }
    };
</script>
<style scoped src="../common.css"></style>
